(() => {
  /* If number of slides is less than slidesPerView * 2, duplicate slides */
  // Returns true if slides were changed (cloned)
  const setSlides = (sliders) => {
    let changed = false;
    if (sliders && sliders.length > 0) {
      sliders.forEach(swiper => {
        let SLIDES_REQUIRED;
        const wrapper = swiper.querySelector('.swiper-wrapper');
        const srcElems = wrapper.querySelectorAll('.logo-list__item');
        const isHorizontal = swiper.classList.contains('logo-list__content--horizontal-carousel');

        if (window.matchMedia("(min-width: 1200px)").matches) {
          if (srcElems.length > 5) {
            SLIDES_REQUIRED = isHorizontal ? 12 : 6;
          } else {
            SLIDES_REQUIRED = srcElems.length;
          }
        } else if (window.matchMedia("(min-width: 990px)").matches) {
          if (srcElems.length > 4) {
            SLIDES_REQUIRED = isHorizontal ? 8 : 6;
          } else {
            SLIDES_REQUIRED = srcElems.length;
          }
        } else if (window.matchMedia("(min-width: 750px)").matches) {
          if (srcElems.length > 3) {
            SLIDES_REQUIRED = isHorizontal ? 6 : 6;
          } else {
            SLIDES_REQUIRED = srcElems.length;
          }
        } else {
          if (srcElems.length > 2) {
            SLIDES_REQUIRED = isHorizontal ? 4 : 6;
          } else {
            SLIDES_REQUIRED = srcElems.length;
          }
        }

        let currentCount = wrapper.querySelectorAll('.logo-list__item').length;
        while (currentCount < SLIDES_REQUIRED) {
          srcElems.forEach(el => {
            const cloneElem = el.cloneNode(true);
            wrapper.appendChild(cloneElem);
            changed = true;
            currentCount++;
          });
        }
      });
    }
    return changed;
  }

  // Returns true if any slides changed
  const recalculateSlidesLength = () => {
    let changed = false;
    if (setSlides(document.querySelectorAll('.js-slider-logos'))) changed = true;
    if (setSlides(document.querySelectorAll('.js-slider-logos-slow'))) changed = true;
    return changed;
  }

  const initSlider = (section) => {
    let logosSlider;
    let logosSliderSlow;
    if (document.currentScript) {
      logosSlider = document.currentScript.parentElement.querySelectorAll('.js-slider-logos');
      logosSliderSlow = document.currentScript.parentElement.querySelectorAll('.js-slider-logos-slow');
    } else {
      logosSlider = section.querySelectorAll('.js-slider-logos');
      logosSliderSlow = section.querySelectorAll('.js-slider-logos-slow');
    }
    if (logosSlider && logosSlider.length > 0) {
      logosSlider.forEach(el => {
        if (el.swiper && typeof el.swiper.destroy === 'function') {
          el.swiper.destroy(true, true);
          try { delete el.swiper; } catch {}
        }
        const speed1 = el.getAttribute('data-duration');
        new Swiper(el, {
          slidesPerView: el.classList.contains('logo-list__content--horizontal-carousel') ? 2 : 3,
          spaceBetween: 16,
          autoplay: { delay: 1 },
          direction: 'horizontal',
          loop: true,
          speed: speed1,
          shortSwipes: false,
          longSwipes: false,
          allowTouchMove: false,
          breakpoints: {
            750: {
              direction: el.classList.contains('logo-list__content--vertical-carousel') ? 'vertical' : 'horizontal',
              slidesPerView: 3,
              spaceBetween: 20
            },
            990: {
              direction: el.classList.contains('logo-list__content--vertical-carousel') ? 'vertical' : 'horizontal',
              slidesPerView: el.classList.contains('logo-list__content--horizontal-carousel') ? 4 : 3,
              spaceBetween: 24
            },
            1200: {
              direction: el.classList.contains('logo-list__content--vertical-carousel') ? 'vertical' : 'horizontal',
              slidesPerView: el.classList.contains('logo-list__content--horizontal-carousel') ? 6 : 3,
              spaceBetween: 10
            }
          }
        });
      });
    }
    if (logosSliderSlow && logosSliderSlow.length > 0) {
      logosSliderSlow.forEach(el => {
        if (el.swiper && typeof el.swiper.destroy === 'function') {
          el.swiper.destroy(true, true);
          try { delete el.swiper; } catch {}
        }
        const speed2 = el.getAttribute('data-duration');
        new Swiper(el, {
          slidesPerView: 3,
          spaceBetween: 16,
          autoplay: { delay: 1 },
          direction: 'horizontal',
          loop: true,
          speed: speed2,
          shortSwipes: false,
          longSwipes: false,
          allowTouchMove: false,
          breakpoints: {
            750: { direction: 'vertical', slidesPerView: 3, spaceBetween: 20 },
            990: { direction: 'vertical', slidesPerView: 3, spaceBetween: 24 }
          }
        });
      });
    }
  }

  const initSection = (section) => {
    let sectionLogos;

    if (document.currentScript) {
      sectionLogos = document.currentScript.parentElement;
    }
    else {
      sectionLogos = section;
    }


    // Debounce function
    function debounce(func, wait) {
      let timeout;
      return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    }

    const reinitLogoSliders = () => {
      const sliders = sectionLogos.querySelectorAll('.js-slider-logos');
      const slidersSlow = sectionLogos.querySelectorAll('.js-slider-logos-slow');
      // Only destroy/init if slides changed
      const slidesChanged = recalculateSlidesLength();
      if (slidesChanged) {
        if (sliders.length != 0) {
          sliders.forEach(slider => {
            if (slider.swiper) slider.swiper.destroy();
          });
        }
        if (slidersSlow.length != 0) {
          slidersSlow.forEach(slider => {
            if (slider.swiper) slider.swiper.destroy();
          });
        }
        // Remove swiper-initialized classes to allow re-init
        sliders.forEach(slider => slider.classList.remove('swiper-initialized'));
        slidersSlow.forEach(slider => slider.classList.remove('swiper-initialized'));
        initSlider(sectionLogos);
        setTimeout(() => {
          sliders.forEach(slider => {
            if (slider.swiper && slider.swiper.autoplay && typeof slider.swiper.autoplay.start === 'function') {
              slider.swiper.autoplay.start();
            }
          });
          slidersSlow.forEach(slider => {
            if (slider.swiper && slider.swiper.autoplay && typeof slider.swiper.autoplay.start === 'function') {
              slider.swiper.autoplay.start();
            }
          });
        }, 100);
      }
    };

    const debouncedReinit = debounce(reinitLogoSliders, 200);
    const sectionResizeObserver = new ResizeObserver(() => {
      debouncedReinit();
    });

    recalculateSlidesLength();
    initSlider(sectionLogos);
    setTimeout(() => {
      const sliders = sectionLogos.querySelectorAll('.js-slider-logos');
      const slidersSlow = sectionLogos.querySelectorAll('.js-slider-logos-slow');
      sliders.forEach(slider => {
        if (slider.swiper && slider.swiper.autoplay && typeof slider.swiper.autoplay.start === 'function' && !slider.swiper.autoplay.running) {
          slider.swiper.autoplay.start();
        }
      });
      slidersSlow.forEach(slider => {
        if (slider.swiper && slider.swiper.autoplay && typeof slider.swiper.autoplay.start === 'function' && !slider.swiper.autoplay.running) {
          slider.swiper.autoplay.start();
        }
      });
    }, 100);
    sectionResizeObserver.observe(sectionLogos);
  }


  // Export for global use (e.g. from pricing-tabs.js)
  window.initLogoSliders = initSection;
  initSection();

  // Debounce section load handler
  document.addEventListener("shopify:section:load", debounce(function (e) {
    if (e && e.detail && e.detail.target) {
      initSection(e.detail.target);
    }
  }, 200));
})()